/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_Type_HeaderInputs */



/**
* | output |
* | --- |
* | "Type" |
*
* @param {Explorer_Search_Type_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_type_header = /** @type {((inputs?: Explorer_Search_Type_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_Type_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Type")
	if (locale === "de") return /** @type {LocalizedString} */ ("Type")
	if (locale === "it") return /** @type {LocalizedString} */ ("Type")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Type")
	if (locale === "es") return /** @type {LocalizedString} */ ("Type")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Type")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Type")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Type")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Type")
	return /** @type {LocalizedString} */ ("Type")
});